import { Navigate, useSearchParams } from 'react-router-dom';
import { AccountingHubPage } from './AccountingHubPage';
import { legacyTabToPath } from './tabRoutes';

/** `/accounting` index: redirect legacy ?tab= or show hub. */
export function AccountingIndexPage() {
  const [params] = useSearchParams();
  const tab = params.get('tab');
  const target = legacyTabToPath(tab);
  if (target && target !== '/accounting') {
    return <Navigate to={target} replace />;
  }
  return <AccountingHubPage />;
}
